// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3LuMw","content":"LayoutSettings_content__L7vJi"};